import React from 'react';
import { Spinner } from 'design-system';
import { useObjectPreview } from 'corp/hooks/smartId/useObjectPreview';
import { INamedObjectTypes } from '@scale/shared/types/lookup';
import IsomorphicLink from 'corp/components/UI/IsomorphicLink';
import { DeliveredBatchLookupDTO } from '@scale/shared/ots';

const OTSDeliveredBatchPreview: React.FC<{ id: string }> = ({ id }) => {
  const {
    value: otsDeliveredBatch,
    loading,
    error,
  } = useObjectPreview<DeliveredBatchLookupDTO>(id, INamedObjectTypes.OTSDeliveredBatch);
  if (error) return <span>Sorry, there was an error</span>;
  if (loading) return <Spinner />;

  return (
    <div className="user-preview">
      <style jsx>{`
        .user-preview__banner {
          font-weight: bold;
          padding: 10px;
          display: flex;
          align-items: center;
        }

        .user-preview__thing-list > div {
          display: flex;
        }

        .user-preview__thing-list strong {
          color: #666;
          margin-right: 10px;
          min-width: 120px;
          text-align: right;
        }
      `}</style>
      <div className="user-preview__banner">
        <h3 style={{ margin: '0 5px' }}>{otsDeliveredBatch?.note}</h3>
      </div>
      <div className="user-preview__body">
        <div className="user-preview__thing-list">
          <div>
            <strong>Lookup page</strong>
            <IsomorphicLink target="_blank" rel="noopener noreferrer" href={`/lookup/${id}`}>
              {id}{' '}
            </IsomorphicLink>
          </div>
          <div>
            <strong>Project</strong>
            <IsomorphicLink
              target="_blank"
              rel="noopener noreferrer"
              href={`/lookup/${otsDeliveredBatch?.projectId}`}
            >
              {otsDeliveredBatch?._project?.name}{' '}
            </IsomorphicLink>
          </div>
          <div>
            <strong>OTS Subscription</strong>
            <IsomorphicLink
              target="_blank"
              rel="noopener noreferrer"
              href={`/lookup/${otsDeliveredBatch?.otsSubscription}`}
            >
              {otsDeliveredBatch?._otsSubscription?.customerCodename}{' '}
            </IsomorphicLink>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OTSDeliveredBatchPreview;
